import _ from 'lodash';
import { apiFetch } from './utility';

const REGISTRY_ROWS = 'registry/search';

const initialState = {
	registryRows : undefined,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case REGISTRY_ROWS:
			return {
				...state,
				registryRows : action.registryRows,
			};
		default:
			return state;
	}
};

export const searchRegistry = ({callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'registry.search',
			dispatch,
			callback : (err, r) => {
				const registryRows = _.get(r, ['collections', 'registryCollection']);
				dispatch({
					type: REGISTRY_ROWS,
					registryRows,
				});
				callback(err);
			}
		});
	};
};


export const updateRegistry = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'registry.update',
			params,
			dispatch,
			successMessage : `Update successful.`,
			callback,
		});
	};
};
